import { apiClient } from "./api";

export interface AuditLog {
  id: string;
  tenant_id: string;
  actor_id: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  details: Record<string, unknown>;
  created_at: string;
}

export interface AuditLogListResponse {
  logs: AuditLog[];
  total: number;
  limit: number;
  offset: number;
}

export async function listAuditLogs(params?: {
  action?: string;
  resource_type?: string;
  resource_id?: string;
  limit?: number;
  offset?: number;
}): Promise<AuditLogListResponse> {
  const response = await apiClient.get("/audit/logs", { params });
  return response.data;
}

export interface AuditUsageResponse {
  total: number;
  days: number;
  by_action: Record<string, number>;
  by_source: Record<string, number>;
}

export async function getAuditUsage(days = 30): Promise<AuditUsageResponse> {
  const response = await apiClient.get("/audit/usage", { params: { days } });
  return response.data;
}
